import BopisBar from '@cat/bopis-bar';
import useBopis from '../../hooks/useBopis';

export const BopisBarFragment = ({
  position,
  abbrNameForTealium,
  businessUnitId,
  categoryName,
  datalayer,
  mediator,
  pageType,
  selectedNodes,
}) => {
  const { enabled, bopisData } = useBopis();

  return enabled ? (
    <BopisBar
      position={position}
      abbrNameForTealium={abbrNameForTealium}
      bopisData={bopisData}
      businessUnitId={businessUnitId}
      categoryName={categoryName}
      datalayer={datalayer}
      mediator={mediator}
      pageType={pageType}
      selectedNodes={selectedNodes}
      key="bopis-bar"
    />
  ) : null;
};
